export type ItemType = 'Company' | 'Manufacturer' | 'Abstract' | 'MultiSource' | 'SingleSource'

export const availableItemTypes: ItemType[] = ['Company', 'MultiSource', 'SingleSource', 'Manufacturer', 'Abstract']

export const convertItemTypeLabel = (input: ItemType): string | null => {
    const map = new Map<string, string>([
        ['Company', 'Company Item'],
        ['SingleSource', 'Single Source Item'],
        ['MultiSource', 'Multi Source Item'],
        ['Manufacturer', 'Manufacturer Item'],
        ['Abstract', 'Abstract Item']
    ])

    return map.get(input) || null
}
